import angular from 'angular';
import homeConfig from './home.config';

import home from '../../containers/home';

const homeModule = angular.module('meredicte.home', [])
  .component('appHome', home)
  .config(homeConfig);

export default homeModule;



// WEBPACK FOOTER //
// ./src/modules/home/home.module.js